import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import API from '../../api';

import InputUpload from '../../components/InputUpload';

import { updateRetailer } from '../../actions/Retailer';
import { useRefreshToken } from '../../common/hooks/useRefreshToken';
import Loader from '../../components/Loader';
import notify from '../../components/Notification/helper';
import { getTranslation } from '../../utils/translate';
import BarcodeForm from '../../components/BarcodeForm';
import CreatePage from '../../layouts/CreatePage';

function BarcodeCreate() {
  const params = useParams();

  const barcodeId = params.qrCodeId;

  const retailer = useSelector(state => state.retailer);

  useRefreshToken();

  const [loading, setLoading] = useState(false);

  const statusOptions = [
    'published',
    'draft',
    'archived'
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <CreatePage
      title={'Create Barcode'}
      breadcrumbsLinks={[
        {
          url: "/codes-menu",
          content: "Codes",
        },
        {
          url: `/barcodes`,
          content: 'Barcodes',
        }
      ]}
    >
      <Box sx={{ flexGrow: 1, my: 3 }}>
        <BarcodeForm />
      </Box>
    </CreatePage>
  )
}

export default BarcodeCreate